import { Box, Button, LinearProgress, Typography } from '@material-ui/core';
import { Visibility, CloudDownloadOutlined } from '@material-ui/icons';
import CustomSlider from 'components/CustomSlider';
import DialogPreviewLibrary from 'components/DialogPreview';
import { toast } from 'react-toastify';
import { LibraryData } from 'services/dataService';
import Interweave from 'interweave';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { useSelector } from 'react-redux';

/**
 *
 * @param {[{banner:string name:string description:string description:string liked_course:boolean id_company_course:string assigned: boolean}]} courses
 * @param {(id_company_course: string)=> {}} onLike
 * @param {(id_company_course: string)=> {}} onActionClick
 */
const LibrariesSlider = ({
  finished,
  courses,
  onActionClick,
  slidesNumber,
  renderOnTrail,
  progress,
  user,
  isKnowledgeTrailPage,
  ...props
}) => {
  const { t } = useTranslation(['button', 'toastify']);
  const [slidesToShow, setSlidesToShow] = React.useState(4);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewType, setPreviewType] = useState(null);
  const [previewName, setPreviewName] = useState(null);
  const [modalStatus, setModalStatus] = useState(false);
  const { company } = useSelector((state) => state);

  const classes = useStyles();

  const handlePreview = async (categoryId) => {
    const library = courses.find(c => c.id === categoryId);
    try {
      const formValues = {
        fileName: library?.urlfile,
        fileType: library?.file_type,
        iduser: user,
        idlibrary: library?.id,
      };

      const signedurls3 = await LibraryData.signs3geturlstudent(formValues);
      const url = signedurls3.data.signedUrl;

      setPreviewUrl(url);
      setPreviewType(library?.file_type);
      setPreviewName(library?.title);
      setModalStatus(true);
    } catch (error) {
      console.error('Error fetching file for preview', error);
      toast.error(t('toastify:commons.toast_error_download_library'));
    }
  };

  const handleDownload = async (categoryId) => {
    const library = courses.find(c => c.id === categoryId);

    try {
      toast.info(t('toastify:commons.toast_start_download_library'));
      const formValues = {
        fileName: library?.urlfile,
        fileType: library?.file_type,
        iduser: user,
        idlibrary: library?.id,
      };

      const signedurls3 = await LibraryData.signs3geturlstudent(formValues);
      const response = await fetch(signedurls3.data.signedUrl);
      const blob = await response.blob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = library?.nameorigem;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading file', error);
      toast.error(t('toastify:commons.toast_error_download_library'));
    }
  };

  const sortElements = renderOnTrail
    ? (a, b) => (a?.order > b?.order ? 1 : -1)
    : (a, b) => (a.name > b.name ? 1 : -1);

  return (
    <CustomSlider
      itens={courses}
      slidesNumber={slidesNumber}
      slidesToShow={slidesToShow}
      setSlidesToShow={setSlidesToShow}
      slideTeste={renderOnTrail ? finished : true}
      {...props}
    >
      {courses?.sort(sortElements)?.map((course, index) => {
        return (
          <div key={index} className={classes.slidesShow}>
            <Box
              className={classes.card}
              style={{ width: slidesToShow <= 2 ? '100%' : 'unset' }}
            >
              <Box>
                <Button >
                  <img
                    className={
                      course?.url ? classes.mediaKnowledgeTrail : classes.companyLogo
                    } 
                    src={course?.url || company?.theme?.logo?.url}      
                  />
                </Button>
                <Box className={classes.cardBody}>
                  <Typography component="span" className={classes.header}>
                    {course.title}
                  </Typography>
                  <Box className={classes.description}>
                    <Interweave
                      content={
                        course?.description?.length ? course?.description : '-'
                      }
                    />
                  </Box>
                  <Box className={classes.action}>
                    <Box className={classes.accessButton}>
                      <Button
                        size="small"
                        color="primary"
                        onClick={() => handlePreview(course?.id)}
                        className={classes.actionButton}
                      >
                        <Visibility />
                      </Button>
                    </Box>
                    <Button
                      size="small"
                      color="primary"
                      startIcon={<CloudDownloadOutlined />}
                      onClick={() => handleDownload(course?.id)}
                    >
                      Download
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
            <DialogPreviewLibrary
              previewType={previewType}
              previewUrl={previewUrl}
              previewName={previewName}
              modalStatus={modalStatus}
              closeModal={setModalStatus}
            />
          </div>
        );
      })}
    </CustomSlider>
  );
};
export default LibrariesSlider;